export const CATEGORY_VALUES = ['beauty', 'fashion', 'food', 'lifestyle', 'travel'] as const;

export type CategoryValue = (typeof CATEGORY_VALUES)[number];

export interface CategoryOption {
  key: string;
  value: 'all' | CategoryValue;
}

export const filterCategories: CategoryOption[] = [
  { key: 'creators.filter_all', value: 'all' },
  ...CATEGORY_VALUES.map((v) => ({ key: `creators.filter_${v}`, value: v as CategoryValue })),
];

export const joinCategories: { value: string; labelKey: string }[] = [
  { value: '', labelKey: 'creators.join_category_placeholder' },
  ...CATEGORY_VALUES.map((v) => ({ value: v, labelKey: `creators.filter_${v}` })),
];